var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"codemirror-container"},[_c('codemirror',{ref:"myCmGenerate",staticClass:"code-mirror",attrs:{"options":_vm.cmOptions},on:{"input":_vm.onCmCodeChange,"beforeChange":_vm.onBeforeChange},model:{value:(_vm.currCode),callback:function ($$v) {_vm.currCode=$$v},expression:"currCode"}})],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c385153c","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/workspace/components/self-code-mirrors/shell-code-mirror.vue
// module id = null
// module chunks = 